import type { DashboardConfig } from '../../types/gotypes'
import type { DashboardSettingsSaveUpdates } from './DashboardSettingsModal'

// Maps a DashboardSettingsModal save payload (camelCase, e.g. `keyMetrics`)
// onto the stored DashboardConfig (snake_case, e.g. `key_metrics`). Spreading
// the payload straight into the config drops `key_metrics` and persists a
// stray `keyMetrics` key — always go through this mapping instead.
// Pages are replaced only when the config already has pages (the modal's
// About tab edits per-page context; a page-less dashboard stays page-less).
export function applyDashboardSettingsSave(
  config: DashboardConfig,
  updates: DashboardSettingsSaveUpdates
): DashboardConfig {
  return {
    ...config,
    name: updates.name,
    description: updates.description,
    objectives: updates.objectives,
    key_metrics: updates.keyMetrics,
    ...(config.pages && config.pages.length > 0 ? { pages: updates.pages } : {}),
  }
}
